import {sortByReverse} from 'src/utilities/utils'
import Vue from 'vue'
import Constants from 'src/utilities/constants'
import axios from 'axios'
import {addHeaders} from 'src/utilities/authHeader'
import {make} from 'vuex-pathify'

let initialState = {
  deadLetterQueues: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
const mutations = make.mutations(state)

mutations.deadLetterQueues = (state, queues) =>{
  state.deadLetterQueues = sortByReverse(queues, 'count')
}

const _queuesStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchDeadLetterQueues({ commit }) {
      try {
        const url = process.env.VUE_APP_PTRAC_API_URI + '/queues'
        const response = await axios.get(url, { headers: await addHeaders(Constants.HEADERS.HTTP_PROXY_API.headers) })

        commit('deadLetterQueues', response.data)

        return {
          result: Constants.RETURN_CODES.SUCCESS
        }
      } catch (err) {
        return {
          result: Constants.RETURN_CODES.ERROR,
          message: err
        }
      }
    },
    async requeue({}, queueName) {
      try {
        const url = process.env.VUE_APP_CORS_HTTP_PROXY_URI + '/requeue'
        await axios.put(url, queueName, { headers: await addHeaders(Constants.HEADERS.HTTP_PROXY_API.headers) })

        return {
          result: Constants.RETURN_CODES.SUCCESS
        }
      } catch (err) {
        return {
          result: Constants.RETURN_CODES.ERROR,
          message: err
        }
      }
    }
  }
}

export {_queuesStore}
export default _queuesStore
